/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_InactivateInputs */

const en_task_flow_inactivate = /** @type {(inputs: Task_Flow_InactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactivate resolution`)
};

const pt_br2_task_flow_inactivate = /** @type {(inputs: Task_Flow_InactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inativar resolução`)
};

/**
* | output |
* | --- |
* | "Inactivate resolution" |
*
* @param {Task_Flow_InactivateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_inactivate = /** @type {((inputs?: Task_Flow_InactivateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_InactivateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_inactivate(inputs)
	return pt_br2_task_flow_inactivate(inputs)
});